import { useEffect, useState } from 'react';

import fetch2 from 'Util/fetch';
import getConfig from 'Util/Config';

import { OnlineSVGIcon } from './Components/Icons/OnlineSVGIcon';
import { OfflineSVGIcon } from './Components/Icons/OfflineSVGIcon';
import { WarningSVGIcon } from './Components/Icons/WarningSVGIcon';

export const STATUS = {
  ONLINE: 'ONLINE',
  OFFLINE: 'OFFLINE',
  WARNING: 'WARNING',
};

export const mapHealthCheckUrl = () => {
  const { userApi, assetUrl, userPortalUrl, byteArkUrl } = getConfig();
  let userApiUrl = new URL(userApi);
  userApiUrl = userApiUrl.origin;

  const API_LIST = [
    { title: 'User API', url: `${userApiUrl}/user-api/users/me` },
    { title: 'Classroom API', url: `${userApiUrl}/api/users/me` },
    { title: 'Exam API', url: `${userApiUrl}/api/users/me` },
    { title: 'User Portal', url: `${userPortalUrl}/users/me` },
    { title: 'Asset', url: `${assetUrl}/health-check` },
    // Waiting for support timelogging-api
    // { title: 'Time Logging API', url: `${userApiUrl}/timelogging-api/health-check` },
  ];

  const BYTEARK_API = { title: 'ByteArk', url: `${byteArkUrl}/.cdn-trace` };

  return { API_LIST, BYTEARK_API };
};

export const getStatusType = (status) => {
  switch (status) {
    case STATUS.OFFLINE:
      return {
        icon: OfflineSVGIcon,
        color: 'danger',
        text: 'ออฟไลน์',
      };
    case STATUS.WARNING:
      return {
        icon: WarningSVGIcon,
        color: 'warning',
        text: 'ระบบมีการตอบสนองช้า',
      };
    case STATUS.ONLINE:
    default:
      return {
        icon: OnlineSVGIcon,
        color: 'success',
        text: 'ออนไลน์',
      };
  }
};

export const useHealthCheck = (item, timeResponseConfig) => {
  const [data, setData] = useState(null);
  const [status, setStatus] = useState(STATUS.ONLINE);
  const [loading, setLoading] = useState(false);

  const { title, url } = item;

  const isByteArk = title === 'ByteArk';
  const isAsset = title === 'Asset';
  const isUserPortal = title === 'User Portal';

  const shouldUseFetchDefault = isByteArk || isAsset || isUserPortal;
  const fetchApi = shouldUseFetchDefault ? fetch : fetch2;

  const fetchData = async () => {
    setLoading(true);
    const timeStart = Date.now();

    await fetchApi(url)
      .then(async (res) => {
        setLoading(false);
        const timeEnd = Date.now();
        const timeResponse = timeEnd - timeStart;

        let response = res;
        if (isByteArk || isUserPortal) response = await res.json();
        if (isAsset) response = await res.text();

        if (response?.id || response?.message === 'Unauthorized' || response === 'OK') {
          if (timeResponse > timeResponseConfig) {
            setStatus(STATUS.WARNING);
          } else {
            setStatus(STATUS.ONLINE);
          }
        } else {
          setStatus(STATUS.OFFLINE);
        }
        setData(response);
      })
      .catch((err) => {
        setLoading(false);
        if (err.statusCode === 401) {
          setStatus(STATUS.ONLINE);
        } else {
          setStatus(STATUS.OFFLINE);
        }
      });
  };

  useEffect(() => {
    fetchData();
  }, [url]);

  return { data, status, title, loading, refetch: fetchData };
};
